import { FC, useState } from 'react';

import { RebateDeliveredSection } from '../../components/agencyGiftSettlement/RebateDeliveredSection';
import { RebateDraftSection } from '../../components/agencyGiftSettlement/RebateDraftSection';
import { RebateHistoryYearCalendar } from '../../components/agencyGiftSettlement/RebateHistoryYearCalendar';
import { AgencyGiftSettlementData } from '../../hooks/useAgencyGiftSettlementData';

// ─────────────────────────────────────────────
// AgencyGiftSettlementView
//
// 배송형 정산 화면 본체 (데이터는 주입받는다).
// 단독 페이지(AgencyGiftSettlementContainer)와 통합 정산 페이지의 '배송형' 탭이
// 같은 화면을 공유하되, 통합 페이지에선 훅을 한 번만 돌려 데이터를 넘겨준다.
// ─────────────────────────────────────────────

type AgencySettlementTab = 'pendingAndHistory' | 'delivered';

const TABS: { key: AgencySettlementTab; label: string }[] = [
  { key: 'pendingAndHistory', label: '정산 예정 및 완료 내역' },
  // 실제 데이터는 rebateSettlement=null(미정산) 배송완료 건만 조회하므로
  // 라벨도 "미정산 배송 내역"으로 의미를 명확히 한다.
  { key: 'delivered', label: '미정산 배송 내역' },
];

export const AgencyGiftSettlementView: FC<AgencyGiftSettlementData> = ({
  historyItems,
  historyLoading,
  deliveredEntries,
  deliveredLoading,
}) => {
  const [tab, setTab] = useState<AgencySettlementTab>('pendingAndHistory');

  return (
    <div>
      {/* 탭 */}
      <div className="mb-4 border-b border-gray-200">
        <div className="flex gap-0">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setTab(t.key)}
              className={`w-44 border-b-2 px-5 py-2.5 text-center text-sm font-medium transition-colors ${
                tab === t.key
                  ? 'border-indigo-600 text-indigo-600'
                  : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      {/* 정산예정 / 정산완료 탭 */}
      {tab === 'pendingAndHistory' && (
        <div className="space-y-10">
          <div className="rounded-lg bg-white p-6 shadow">
            <RebateDraftSection historyItems={historyItems} loading={historyLoading} />
          </div>
          <div className="rounded-lg bg-white p-6 shadow">
            <h3 className="mb-4 font-semibold text-gray-800">정산 완료 내역</h3>
            <RebateHistoryYearCalendar
              historyItems={historyItems}
              loading={historyLoading}
            />
          </div>
        </div>
      )}

      {/* 배송완료 탭 */}
      {tab === 'delivered' && (
        <div className="rounded-lg bg-white p-6 shadow">
          <RebateDeliveredSection
            deliveredEntries={deliveredEntries}
            loading={deliveredLoading}
          />
        </div>
      )}
    </div>
  );
};
